import React, { useEffect, useState } from 'react';
import { Link, NavLink } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import axios from 'axios';

const imageURL = process.env.REACT_APP_IMAGEURL;
const apiDomain = process.env.REACT_APP_DOMAIN;

export default function Header(props) {
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() =>{
    axios.get(`${apiDomain}/api/session-data`).then((res)=>{
        if(res.data.id) {
          props.setAdminData({...res.data})
        }
    }).catch(err=>{
        alert('Something went wrong, Please try again!')
    })
  }, [])

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <>
      {['lg'].map((expand) => (
        <Navbar key={expand} expand={expand} className="header bg-white">
          <Container className='py-1'>
            <Link to={apiDomain} target='_blank'><img src={`${imageURL}/premieragile.png`} alt='Logo' /></Link>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
            <Navbar.Offcanvas className='mobile-canvas'
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end">
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                  Menus
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="header shadow-none justify-content-end align-items-center flex-grow-1">
                  <NavLink className="links pb-3 pb-lg-0 pe-lg-4" to="/">Home</NavLink>
                  <NavLink className="links pb-3 pb-lg-0 pe-lg-4" target='_blank' to={`${apiDomain}/about-us/`}>About Us</NavLink>
                  <NavLink className="links pb-3 pb-lg-0" target='_blank' to={`${apiDomain}/contact-us/`}>Contact Us</NavLink>
                  
                  {props.adminData?.id ? <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} className="d-flex align-items-center position-relative ms-lg-4">
                      {props.adminData.avatar ? <img src={props.adminData.avatar} alt='Player' style={{width: '50px', borderRadius: '50%'}} />
                      : <img src={`${imageURL}/invite-player.svg`} alt='Player' />}
                      <div className="ps-2">
                          <p className='mb-0 lh-sm cl-blue fs-6'>Hello</p>
                          <h2 className='mb-0 fs-18 cl-darkblue'>{props.adminData.name}
                          <svg className='align-text-top' xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                          <mask id="mask0_127_118" style={{'mask-type':'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="24">
                          <rect x="0.00195312" y="-6.10352e-05" width="24" height="24" fill="#D9D9D9"/>
                          </mask>
                          <g mask="url(#mask0_127_118)">
                          <path d="M12.6018 11.9999L8.70176 8.09993C8.51842 7.91659 8.42676 7.68326 8.42676 7.39993C8.42676 7.11659 8.51842 6.88326 8.70176 6.69993C8.88509 6.51659 9.11842 6.42493 9.40176 6.42493C9.68509 6.42493 9.91842 6.51659 10.1018 6.69993L14.7018 11.2999C14.8018 11.3999 14.8726 11.5083 14.9143 11.6249C14.9559 11.7416 14.9768 11.8666 14.9768 11.9999C14.9768 12.1333 14.9559 12.2583 14.9143 12.3749C14.8726 12.4916 14.8018 12.5999 14.7018 12.6999L10.1018 17.2999C9.91842 17.4833 9.68509 17.5749 9.40176 17.5749C9.11842 17.5749 8.88509 17.4833 8.70176 17.2999C8.51842 17.1166 8.42676 16.8833 8.42676 16.5999C8.42676 16.3166 8.51842 16.0833 8.70176 15.8999L12.6018 11.9999Z" fill="#230F72"/>
                          </g>
                          </svg>
                          </h2>
                      </div>
                      {isHovered ? <div className='account-menu bg-white p-4 br-20 shadow-sm position-absolute top-100 end-0'>
                        <ul className='mb-0 ps-0'>
                          <li className='pb-2'>
                            <NavLink to="/dashboard/create-game" className='cl-darkblue'><svg className='me-2' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <mask id="mask0_3_362" style={{'mask-type':'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                <rect width="24" height="24" fill="#D9D9D9"/>
                              </mask>
                              <g mask="url(#mask0_3_362)">
                                <path d="M5 11C4.45 11 3.97917 10.8042 3.5875 10.4125C3.19583 10.0208 3 9.55 3 9V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H9C9.55 3 10.0208 3.19583 10.4125 3.5875C10.8042 3.97917 11 4.45 11 5V9C11 9.55 10.8042 10.0208 10.4125 10.4125C10.0208 10.8042 9.55 11 9 11H5ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V15C3 14.45 3.19583 13.9792 3.5875 13.5875C3.97917 13.1958 4.45 13 5 13H9C9.55 13 10.0208 13.1958 10.4125 13.5875C10.8042 13.9792 11 14.45 11 15V19C11 19.55 10.8042 20.0208 10.4125 20.4125C10.0208 20.8042 9.55 21 9 21H5ZM15 11C14.45 11 13.9792 10.8042 13.5875 10.4125C13.1958 10.0208 13 9.55 13 9V5C13 4.45 13.1958 3.97917 13.5875 3.5875C13.9792 3.19583 14.45 3 15 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V9C21 9.55 20.8042 10.0208 20.4125 10.4125C20.0208 10.8042 19.55 11 19 11H15ZM15 21C14.45 21 13.9792 20.8042 13.5875 20.4125C13.1958 20.0208 13 19.55 13 19V15C13 14.45 13.1958 13.9792 13.5875 13.5875C13.9792 13.1958 14.45 13 15 13H19C19.55 13 20.0208 13.1958 20.4125 13.5875C20.8042 13.9792 21 14.45 21 15V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H15Z" fill="#D157DB"/>
                              </g>
                            </svg> Dashboard</NavLink>
                          </li>
                          <li>
                            <Link to={apiDomain} className='cl-darkblue'><svg className='me-2' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <mask id="mask0_3_380" style={{'mask-type':'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                <rect width="24" height="24" fill="#EF4242"/>
                              </mask>
                              <g mask="url(#mask0_3_380)">
                                <path d="M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H11C11.2833 3 11.5208 3.09583 11.7125 3.2875C11.9042 3.47917 12 3.71667 12 4C12 4.28333 11.9042 4.52083 11.7125 4.7125C11.5208 4.90417 11.2833 5 11 5H5V19H11C11.2833 19 11.5208 19.0958 11.7125 19.2875C11.9042 19.4792 12 19.7167 12 20C12 20.2833 11.9042 20.5208 11.7125 20.7125C11.5208 20.9042 11.2833 21 11 21H5ZM17.175 13H10C9.71667 13 9.47917 12.9042 9.2875 12.7125C9.09583 12.5208 9 12.2833 9 12C9 11.7167 9.09583 11.4792 9.2875 11.2875C9.47917 11.0958 9.71667 11 10 11H17.175L15.3 9.125C15.1167 8.94167 15.025 8.71667 15.025 8.45C15.025 8.18333 15.1167 7.95 15.3 7.75C15.4833 7.55 15.7167 7.44583 16 7.4375C16.2833 7.42917 16.525 7.525 16.725 7.725L20.3 11.3C20.5 11.5 20.6 11.7333 20.6 12C20.6 12.2667 20.5 12.5 20.3 12.7L16.725 16.275C16.525 16.475 16.2875 16.5708 16.0125 16.5625C15.7375 16.5542 15.5 16.45 15.3 16.25C15.1167 16.05 15.0292 15.8125 15.0375 15.5375C15.0458 15.2625 15.1417 15.0333 15.325 14.85L17.175 13Z" fill="#D157DB"/>
                              </g>
                            </svg> Log out</Link>
                          </li>
                        </ul>
                      </div> : ''}
                  </div> : ''}
                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}
    </>
  )
}
